import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
/* eslint-disable */
import editorStyle from "../util/defaultStyle";
import { shapeBase } from '@antv/g6/lib/shape/shapeBase';
import Shape from '@antv/g6/lib/shape/shape';
export default function (G6) {
  Shape.registerFactory('controlPoint', {
    defaultShapeType: 'marker',
    getShape: function getShape(type) {
      var shapeObj = Object.assign({}, shapeBase, {
        type: 'marker',
        itemType: type,
        drawShape: function drawShape(cfg, group) {
          var style = this.getShapeStyle(cfg);
          var shape = group.addShape('marker', {
            attrs: _objectSpread(_objectSpread({}, style), {}, {
              symbol: 'square'
            }),
            name: 'controlPoint-shape',
            draggable: true
          });
          return shape;
        },
        setState: function setState(name, value, item) {
          if (name === 'active') {
            if (value) {
              this.update({
                style: _objectSpread({}, editorStyle.pointPointHoverStyle)
              }, item);
            } else {
              this.update({
                style: _objectSpread({}, editorStyle.pointPointStyle)
              }, item);
            }
          }
        }
      });
      return shapeObj;
    }
  });
}